<template>
  <div class="col-xs-12">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title"><i class="fa fa-map-marker mr-5"></i>{{'stores' | translate}}</h3>
        <div class="box-tools pull-right">
          <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
        </div>
      </div>
      <div class="box-controls">
        <div class="row">
          <div class="col-xs-12">
            <button type="button" class="btn btn btn-sm btn-danger ml-5 pull-right" data-toggle="modal" data-target="#bulk-update-modal">
              <i class="fa fa-cog mr-5"></i>
              {{'bulk_update_stores' | translate}}
            </button>
          </div>
        </div>
      </div>
      <div class="box-body">
        <template v-if="loading">
          <div class="row">
            <div class="col-xs-12 text-center">
              <img class="loading-gif" src="/static/img/blabla.svg"/>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="row">
            <div class="col-xs-12">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>{{'status' | translate | capitalize}}</th>
                  <th>{{'myplace-view' | translate | capitalize }}</th>
                  <th class="col-xs-2">{{'erp_info' | translate | capitalize}}</th>
                  <th>{{'info' | translate | capitalize}}</th>
                  <th class="col-xs-2">{{'store_address' | translate}}</th>
                  <th class="col-xs-2">{{'shipping_address' | translate}}</th>
                  <th class="col-xs-3">{{'mp_status' | translate}}</th>
                  <th>{{'edit' | translate}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item, index in pagination">
                  <td>
                    <div class="btn-group btn-group-sm" data-toggle="btn-toggle">
                      <div v-if="item.show_in_list">
                        <button type="button" :class="['btn btn-success btn-sm', item.is_active ? 'active' : '']" @click="toggleActivation(true, item.id, index)"><i class="fa fa-check"></i></button>
                        <button type="button" :class="['btn btn-danger btn-sm', !item.is_active ? 'active' : '']" @click="toggleActivation(false, item.id, index)"><i class="fa fa-ban"></i></button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div>
                      <button type="button" :class="['btn btn-success btn-sm', item.show_in_list ? 'active' : '']" @click="toggleShowInList(true, item.id, index)"><i class="fa fa-check"></i></button><br>
                      <button type="button" :class="['btn btn-danger btn-sm', !item.show_in_list ? 'active' : '']" @click="toggleShowInList(false, item.id, index)"><i class="fa fa-ban"></i></button>
                    </div>
                  </td>
                  <td>
                    <div v-if="item.show_in_list">
                    <small class="text-muted">{{'order_email' | translate}}:<br></small>
                    {{item.order_email}}<br>
                    <small class="text-muted">{{'cnc_email' | translate}}:<br></small>
                    {{item.reservation_email}}<br>
                    </div>
                    <div>
                    <span class="text-muted">{{'erp_store_id' | translate}}:</span><br/>
                    {{item.erp_store_id}}
                    </div>

                  </td>
                  <td>
                    <p>
                      <div v-if="item.show_in_list"><small class="text-muted">SAP-Nummer:</small><br>{{item.sap_number}}</div>
                      <small class="text-muted">Filialnummer:</small><br>
                      {{item.store_number}}<br>
                    </p>
                  </td>
                  <td><p v-if="item.show_in_list">{{item.name}}<br>{{item.street}} {{item.street_no}}<br>{{item.zip_code}} {{item.city}}<br>{{item.contact_email}}<br><small class="text-muted">{{item.country | country}}</small><br></p></td>
                  <td><p v-if="item.show_in_list">{{item.shipping_name}}<br>{{item.shipping_street}} {{item.shipping_street_no}}<br>{{item.shipping_zip_code}} {{item.shipping_city}}<br><small class="text-muted">{{item.shipping_country | country}}</small></p></td>
                  <td>
                    <template v-if="storeData[item.store_number] && item.show_in_list">
                      <button @click="updateStoreMpVisibility(item, {name: 'amazon', active: storeData[item.store_number].amazon === 1 ? 0 : 1})" style="margin-bottom:5px" :class="[storeData[item.store_number].amazon === 1 ? 'btn btn-success btn-sm mr-5 active' : 'btn btn-danger btn-sm active mr-5']" type="button">
                        <i :class="[storeData[item.store_number].amazon === 1 ? 'fa fa-check mr-5' : 'fa fa-ban mr-5']"></i>{{'amazon' | translate}}
                      </button>
                      <button @click="updateStoreMpVisibility(item, {name: 'zalando', active: storeData[item.store_number].zalando === 1 ? 0 : 1})" style="margin-bottom:5px" :class="[storeData[item.store_number].zalando === 1 ? 'btn btn-success btn-sm mr-5 active' : 'btn btn-danger btn-sm active mr-5']" type="button">
                        <i :class="[storeData[item.store_number].zalando === 1 ? 'fa fa-check mr-5' : 'fa fa-ban mr-5']"></i>{{'zalando' | translate}}
                      </button>
                      <button @click="updateStoreMpVisibility(item, {name: 'ti_mp_diverse', active: storeData[item.store_number].spartoo === 1 ? 0 : 1})" style="margin-bottom:5px" :class="[storeData[item.store_number].spartoo === 1 ? 'btn btn-success btn-sm mr-5 active' : 'btn btn-danger btn-sm active mr-5']" type="button">
                        <i :class="[storeData[item.store_number].spartoo === 1 ? 'fa fa-check mr-5' : 'fa fa-ban mr-5']"></i>{{'spartoo' | translate}}
                      </button>
                      <button @click="updateStoreMpVisibility(item, {name: 'ebay', active: storeData[item.store_number].ebay === 1 ? 0 : 1})" style="margin-bottom:5px" :class="[storeData[item.store_number].ebay === 1 ? 'btn btn-success btn-sm mr-5 active' : 'btn btn-danger btn-sm active mr-5']" type="button">
                        <i :class="[storeData[item.store_number].ebay === 1 ? 'fa fa-check mr-5' : 'fa fa-ban mr-5']"></i>{{'ebay' | translate}}
                      </button>
                      <button @click="updateStoreMpVisibility(item, {name: 'mirapodo', active: storeData[item.store_number].mirapodo === 1 ? 0 : 1})" style="margin-bottom:5px" :class="[storeData[item.store_number].mirapodo === 1 ? 'btn btn-success btn-sm mr-5 active' : 'btn btn-danger btn-sm active mr-5']" type="button">
                        <i :class="[storeData[item.store_number].mirapodo === 1 ? 'fa fa-check mr-5' : 'fa fa-ban mr-5']"></i>{{'mirapodo' | translate}}
                      </button>
                      <button @click="updateStoreMpVisibility(item, {name: 'tamaris', active: storeData[item.store_number].tamaris === 1 ? 0 : 1})" style="margin-bottom:5px" :class="[storeData[item.store_number].tamaris === 1 ? 'btn btn-success btn-sm mr-5 active' : 'btn btn-danger btn-sm active mr-5']" type="button">
                        <i :class="[storeData[item.store_number].tamaris === 1 ? 'fa fa-check mr-5' : 'fa fa-ban mr-5']"></i>{{'tamaris' | translate}}
                      </button>
                      <button @click="updateStoreMpVisibility(item, {name: 'check24', active: storeData[item.store_number].check24 === 1 ? 0 : 1})" style="margin-bottom:5px" :class="[storeData[item.store_number].check24 === 1 ? 'btn btn-success btn-sm mr-5 active' : 'btn btn-danger btn-sm active mr-5']" type="button">
                        <i :class="[storeData[item.store_number].check24 === 1 ? 'fa fa-check mr-5' : 'fa fa-ban mr-5']"></i>{{'check24' | translate}}
                      </button>
                      <button @click="updateStoreMpVisibility(item, {name: 'ti_reserve_window', active: storeData[item.store_number].click_and_collect === 1 ? 0 : 1})" style="margin-bottom:5px" :class="[storeData[item.store_number].click_and_collect === 1 ? 'btn btn-success btn-sm mr-5 active' : 'btn btn-danger btn-sm active mr-5']" type="button">
                        <i :class="[storeData[item.store_number].click_and_collect === 1 ? 'fa fa-check mr-5' : 'fa fa-ban mr-5']"></i>{{'click_and_collect' | translate}}
                      </button>
                      <button @click="updateStoreMpVisibility(item, {name: 'ti_sale_window', active: storeData[item.store_number].schuhe_de === 1 ? 0 : 1})" style="margin-bottom:5px" :class="[storeData[item.store_number].schuhe_de === 1 ? 'btn btn-success btn-sm mr-5 active' : 'btn btn-danger btn-sm active mr-5']" type="button">
                        <i :class="[storeData[item.store_number].schuhe_de === 1 ? 'fa fa-check mr-5' : 'fa fa-ban mr-5']"></i>{{'schuhede' | translate}}
                      </button>
                    </template>
                  </td>
                  <td><router-link  v-if="item.show_in_list" :to="'/accounting/companies/' + id + '/stores/' + item.id"><button class="btn btn-info btn-app no-margin"><i class="fa fa-edit"></i>{{'edit' | translate}}</button></router-link></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          </div>
        </template>
      </div>
      <div class="box-footer">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['id', 'pagination', 'storeData', 'loading'],
    data () {
      return {
        count: 25,
        stores: {},
        alerts: [],
        isActive: ''
      }
    },
    methods: {
      updateStoreMpVisibility (store, data) {
        this.$emit('loadingSingleUpdate', {storeInfo:store, dataInfo:data})
      },
      toggleActivation (value, id, index) {
        let data = {
          is_active: value
        }
        this.pagination[index].is_active = value
        API.put(`accounting/companies/${this.id}/stores/${id}`, data)
          .then(response => {
        })
      },
      toggleShowInList(value, id, index) {
        let data = {
          show: value
        }
        this.pagination[index].show_in_list = value
        API.put(`accounting/companies/${this.id}/stores/${id}/showHide`, data)
          .then(response => {
          })
      }
    },
    mounted() {
      this.$nextTick(() => {
      })
    }
  }
</script>
<style>
  .loading-gif {
    padding-top: 8px;
    padding-bottom: 15px;
    width: 15%;
  }
</style>



// WEBPACK FOOTER //
// src/components/tools/Tables/StoresTable.vue